import React from 'react';

import { useIntl } from 'react-intl';

import type { PinType } from '../types';

import { TYPE_ICON_CONFIG } from './typeIconConfig';

interface TypeIconProps {
	type: PinType;
}

/**
 * Renders the icon + accent color for a pinned item's type (epic/goal/project). The icon is the
 * only visual indicator of type on a `PinnedItemRow`, so it carries a real (translated) accessible
 * label rather than being treated as decorative.
 *
 * Icon/color/label come from the shared {@link TYPE_ICON_CONFIG} so pinned rows and search results
 * stay visually identical.
 */
export const TypeIcon = ({ type }: TypeIconProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const { icon: Icon, color, label } = TYPE_ICON_CONFIG[type];

	return <Icon label={formatMessage(label)} color={color} />;
};
